import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { task, waitForProperty } from 'ember-concurrency';

export default class IndexController extends Controller {
  @service account;
  @service masq;
  @service alerts;
  @service store;
  @service router;

  serverErrors = null;
  isTurningOff = false;
  isCodeInvalid = false;
  _confirmedDisablingTwoFactorAuthenticationWhenRequired = false;
  _showConfirmDisablingTwoFactorAuthenticationWhenRequiredModal = false;

  _turnOffTwoFactorAuthenticationTask = task(async (code) => {
    if (this.account.current.twoFactorAuthenticationRequired) {
      this.set('_showConfirmDisablingTwoFactorAuthenticationWhenRequiredModal', true);
      await waitForProperty(this, '_showConfirmDisablingTwoFactorAuthenticationWhenRequiredModal', false);
    }

    if (
      this.account.current.twoFactorAuthenticationRequired &&
      !this._confirmedDisablingTwoFactorAuthenticationWhenRequired
    ) {
      return;
    }

    try {
      await this.model.turnOffTwoFactorAuthentication({ code });

      // refresh current user to reflect new 2FA status
      // be sure to use "/accounts/current" API endpoint, not "/users/..."
      // "/accounts/current" is whitelisted to work for users with 2FA disabled, even when account requires it
      await this.store.queryRecord('account', {});

      this.set('isTurningOff', false);

      if (this.account.current.twoFactorAuthenticationRequired) {
        this.alerts.success(
          'user.twoAuthDisable.successSetItUpAgain',
          'Two-factor authentication is now disabled. You need to set it up again before using Customer.io',
        );
        this.router.transitionTo('authenticated.2fa_setup');
      } else {
        this.alerts.success('user.twoAuthDisable.success', 'Two-factor authentication is now disabled.');
      }
    } catch (err) {
      if (err.errors?.[0]?.status === '400') {
        return this.set('serverErrors', ['Your authentication code is invalid. Try again?']);
      }
      throw err;
    }
  });

  setDefaults() {
    this.setProperties({
      isTurningOff: false,
      isCodeInvalid: false,
      serverErrors: [],
      _confirmedDisablingTwoFactorAuthenticationWhenRequired: false,
      _showConfirmDisablingTwoFactorAuthenticationWhenRequiredModal: false,
    });
  }

  @action
  confirmDisablingTwoFactorAuthentication() {
    this.setProperties({
      _confirmedDisablingTwoFactorAuthenticationWhenRequired: true,
      _showConfirmDisablingTwoFactorAuthenticationWhenRequiredModal: false,
    });
  }

  @action
  resetServerErrors() {
    this.set('serverErrors', []);
  }
}
